function assertUnreachable(locationContext) {
    throw new Error(`Invalid SearchType: ${locationContext}`);
}
export const contextIdSelect = (locationContext, { cityId, destinationId, eventId, }) => {
    switch (locationContext) {
        case 'city':
            return { city_id: cityId };
        case 'destination':
        case 'venue':
            return { destination_id: destinationId };
        case 'event':
            return { event_id: eventId };
        case 'address':
            return {};
        default: {
            assertUnreachable(locationContext);
        }
    }
};
